import { type FetchFanTokenOfferingsParams } from '@capsicum/common';
import { useCallback } from 'react';

import { useFanTokenOfferingQuery } from '../data-access/queries/useFanTokenOfferingQuery';
import { useMainCurrenciesQuery } from '../data-access/queries/useMainCurrenciesQuery';
import {
	type FanTokenOfferingWithPartner,
	type FetchFanTokenOfferingsDataWithPartner
} from '../models/fanTokenOferringWithPartner';

/**
 * Hook that call Fan Token Offerings entering endpoint and returns the list of offerings.
 *
 * @param {FetchFanTokenOfferingsParams} params for the request
 *
 * @returns {Array<FanTokenOfferingWithPartner>} returns react query result. (data, isLoading, ... )
 */

export const useFanTokenOfferings = (params?: FetchFanTokenOfferingsParams) => {
	const { data: walletCurrencies } = useMainCurrenciesQuery(['crypto', 'fiat']);

	const queryParams = {
		...(walletCurrencies?.convertAmountToCurrencies && {
			'convertAmountToCurrencies[]': walletCurrencies.convertAmountToCurrencies
		}),
		...params
	};
	const getFanTokenOfferingsData = useCallback(
		(res: FetchFanTokenOfferingsDataWithPartner): Array<FanTokenOfferingWithPartner> => {
			return res.data.map(offering => {
				const { voteToken, ...rest } = offering;

				return {
					...rest,
					fanToken: voteToken
				};
			});
		},
		[]
	);

	return useFanTokenOfferingQuery(queryParams, getFanTokenOfferingsData);
};
